import { SxProps, Theme } from "@mui/material/styles";

export const USER_DIALOG_FIELD_GRID_SX: SxProps<Theme> = {
  display: "grid",
  gridTemplateColumns: {
    xs: "1fr",
    sm: "repeat(2, minmax(0, 1fr))",
    md: "repeat(3, minmax(0, 1fr))",
  },
  gap: 2,
  pt: 1,
};
